import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import styled from "styled-components";
import { ReportType } from "../api/models/report.models";
import { useTranslation } from "react-i18next";
import { InfoDot } from "../components/infoDot";

const StyledDialog = styled(Dialog)`
  .p-dialog-content {
    padding: 2rem;
    display: flex;
    flex-direction: column;
  }
`;

const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1.5rem 0;
`;

const RadioOption = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: auto;
`;

interface ReportChoiceDialogProps {
  visible: boolean;
  onHide: () => void;
  onSelect: (reportType: ReportType.LIGHT | ReportType.DETAILED) => void;
}

const ReportChoiceDialog: React.FC<ReportChoiceDialogProps> = ({
  visible,
  onHide,
  onSelect,
}) => {
  const { t } = useTranslation();
  const [selectedReportType, setSelectedReportType] = useState<
    ReportType.LIGHT | ReportType.DETAILED
  >(ReportType.LIGHT);

  const handleSelect = () => {
    onSelect(selectedReportType);
    onHide();
  };

  return (
    <StyledDialog
      header={t("header-select-report-type")}
      visible={visible}
      onHide={onHide}
      style={{ width: "500px", minHeight: "400px" }}
    >
      <p>{t("msg-select-report-type")}:</p>

      <RadioContainer>
        <RadioOption>
          <RadioButton
            inputId="light"
            name="reportType"
            value={ReportType.LIGHT}
            onChange={(e) => setSelectedReportType(e.value)}
            checked={selectedReportType === ReportType.LIGHT}
          />
          <InfoDot position="right" text={t("infotext-light-reporting")}>
            <label htmlFor="light">{t("label-light-reporting")}</label>
          </InfoDot>
        </RadioOption>

        <RadioOption>
          <RadioButton
            inputId="detailed"
            name="reportType"
            value={ReportType.DETAILED}
            onChange={(e) => setSelectedReportType(e.value)}
            checked={selectedReportType === ReportType.DETAILED}
          />
          <InfoDot position="right" text={t("infotext-detailed-reporting")}>
            <label htmlFor="detailed">{t("label-detailed-reporting")}</label>
          </InfoDot>
        </RadioOption>
      </RadioContainer>

      <ButtonContainer>
        <Button label={t("cmd-cancel")} outlined onClick={onHide} />
        <Button label={t("cmd-proceed")} onClick={handleSelect} />
      </ButtonContainer>
    </StyledDialog>
  );
};

export default ReportChoiceDialog;
